import {
  LOCK, UNLOCK,
  DARK, MENU,
} from '@/store/mutation-types'

const state = {
  // HACK: Credenciais fixas enquando a autenticação não é implementada.
  identity: {
    name: null,
    givenName: null,
    role: null,
    email: null,
    token: null,
  },

  // Travamento de uma requisição para garantir uma úniva operação por vez.
  [LOCK]: {
    // Um objeto do tipo {Keep.Paper.Design.Link} com dados da requisição.
    link: null,
    // Um objeto do tipo {Keep.Paper.Design.Status} com o resultado.
    status: null,
    // Uma função de conclusão da requisição, depois dela ter sido bem ou mal
    // sucedida.
    termination: null,
    // Uma função de cancelamento da requisição.
    // Quando nulo significa que a requisição não pode ser cancelada.
    cancellation: null,
  },

  [DARK]: false,
  [MENU]: true,
}

const mutations = {
  storeIdentity(state, identity) {
    state.identity = identity
  },

  setDark(state, dark) {
    state.dark = dark
  },

  setMenu(state, menu) {
    state.menu = menu // true ou false - menu visivel ou nao
  },

  [LOCK](state, payload) {
    state[LOCK] ||= {}
    let lock = state[LOCK]
    lock.link = payload.link || lock.link
    lock.status = payload.status || lock.status
    lock.termination = payload.termination || lock.termination
    lock.cancellation = payload.cancellation || lock.cancellation
  },

  [UNLOCK](state) {
    state[LOCK] ||= {}
    state[LOCK].link = null
    state[LOCK].status = null
    state[LOCK].termination = null
    state[LOCK].cancellation = null
  },
}

const actions = {
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}